(function () {
    'use strict';

    function saveProgress($compile, $http, fileUploadsService) {
        return {
            restrict: 'E',
            replace: true,
            link: function (scope, element) {
                var templateUrl = 'workflow/directives/templates/saveProgress.html';

                scope.fileUploads = [];
                scope.fileUploadsService = fileUploadsService;
                scope.$watch(function () { return fileUploadsService.fileUploads; }, function (newValue) {
                    //if (newValue) {
                    //    var width = (fileUploadsService.uploadedBytes /
                    //    fileUploadsService.totalBytes) * 100;
                    //    $('#progressBar').css('width', Math.floor(width) + '%');
                    //}

                    scope.fileUploads = fileUploadsService.fileUploads;

                }, true);

                scope.uploaders = fileUploadsService.uploaders;
                $http.get(templateUrl)
                    .then(function (response) {
                        element.html($compile(response.data)(scope));
                    });
            }
        };
    }

    saveProgress.$inject = ['$compile', '$http', 'fileUploadsService'];

    angular.module('ecap.workflow').directive('saveProgress', saveProgress);
})();
